import {Menu} from "antd";
import Sider from "antd/es/layout/Sider";
import React, {useEffect, useState} from "react";
import { BsChatDots } from "react-icons/bs";
import {useChatbotContext} from "@components/Chatbot/context";
import {TrainingAPI} from "@api/TrainingAPI";
import messages from "@components/Chatbot/Messages";
import dayjs from "dayjs";

let trainingApi = new TrainingAPI();


const MenuItem = ({ conversation }) => {
    const getConversationTitle = () => {
        const title = conversation.messages[1]?.content?.message || "Untitled Conversation";
        const maxLength = 40;
        if (title.length <= maxLength) return title;
        return title.slice(0, maxLength - 1).trimEnd() + "…";
    }

    return (
        <div className="chat-menu-conversation-item">
            <p className="chat-menu-conversation-title">
                {getConversationTitle()}
            </p>
            <p className="chat-menu-conversation-subtitle">
                {dayjs(conversation.created).format('MMM DD hh:mm A')}
            </p>
        </div>

    )
}

const Sidebar = () => {
    const [showSidebar, setShowSidebar] = useState(true);
    const { conversations, setConversations, setConversation, resetConversation } = useChatbotContext();

    const getConversations = () => {
        try {
            trainingApi.getChatbotConversations().then(data => {
                setConversations(data);
            })
        } catch (error) {
            console.error("Error fetching conversations:", error);
        }
    }

    useEffect(() => {
        getConversations();
    }, []);

    const resolveMenuItems = () => {
        let MENU_ITEMS = [
            {
                key: 'newChat',
                label: 'New Conversation',
                icon: <BsChatDots />,
                onClick: () => {
                    // Handle new conversation creation
                    resetConversation()
                }
            }
        ]
        if (showSidebar) {
            // only show conversations if sidebar is expanded
            MENU_ITEMS.push({
                key: "convosGroupHeader",
                label: 'Conversations',
                type: "group",
                children: conversations.map((conversation) => ({
                    key: conversation.id,
                    label: <MenuItem conversation={conversation} />,
                    onClick: () => {
                        // Handle conversation click
                        setConversation(conversation);
                    }
                }))
            });
        }

        return MENU_ITEMS;
    }

    return (
        <Sider
            collapsible
            collapsed={!showSidebar}
            onCollapse={() => setShowSidebar(!showSidebar)}
            className="chat-sidebar"
            width={270}
        >
            <Menu
                theme="light"
                defaultSelectedKeys={[]}
                mode="inline"
                items={resolveMenuItems()}
                className="chat-conversations-list"
            />
        </Sider>
    )
}

export default Sidebar;
